import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
type Props = {
    title: string,
    number: number,
    description: string,
    Icon: any
}
export default function SimpleCard({ title, number, description, Icon }: Props) {
    return (
        <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium">{title}</CardTitle>
                <Icon className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
                <div className="text-2xl font-bold">{number}</div>
                <p className="text-xs text-muted-foreground">{description}</p>
            </CardContent>
        </Card>
    )
}
